import {
  getEnumLabel,
  getPriceCategoryTypeOptions,
} from "Forms/Utils/EnumOptions";
import type { PriceCategoryType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import {
  type InformationSection,
  InformationView,
} from "Shared/InformationView";
import { Price } from "Shared/Price/Price";
import { formatDate } from "Shared/Utils/Format/date";

interface PriceCategoryInformationProps {
  name: string;
  type: PriceCategoryType;
  commissionRate: number;
  defaultPrice: number;
  dateCreated: string;
  dateUpdated: string;
  onEdit?: () => void;
}

export const PriceCategoryInformation = ({
  name,
  type,
  commissionRate,
  defaultPrice,
  dateCreated,
  dateUpdated,
  onEdit,
}: PriceCategoryInformationProps): React.ReactNode => {
  const { t } = useResource();

  const sections: InformationSection[] = [
    {
      items: [
        { label: t(Resources.PriceCategories.Name), value: name },
        {
          label: t(Resources.PriceCategories.Type),
          value: getEnumLabel(getPriceCategoryTypeOptions(), type),
        },
        {
          label: t(Resources.PriceCategories.CommissionRate),
          value: `${(commissionRate * 100).toFixed(0)} %`,
        },
        {
          label: t(Resources.PriceCategories.DefaultPrice),
          value: <Price amount={defaultPrice} />,
        },
        {
          label: t(Resources.PriceCategories.DateCreated),
          value: formatDate(dateCreated),
        },
        {
          label: t(Resources.PriceCategories.DateUpdated),
          value: formatDate(dateUpdated),
        },
      ],
    },
  ];

  return (
    <InformationView
      title={t(Resources.PriceCategories.Detail.Information)}
      editLabel={t(Resources.PriceCategories.Detail.EditInformation)}
      onEdit={onEdit}
      sections={sections}
    />
  );
};
